/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MonitResolutionTypes = {
    Scannable: 'scannable',
    Auditable: 'auditable',
    Evidence: 'evidence'
} as const;
export type MonitResolutionTypes = typeof MonitResolutionTypes[keyof typeof MonitResolutionTypes];


export function MonitResolutionTypesFromJSON(json: any): MonitResolutionTypes {
    return MonitResolutionTypesFromJSONTyped(json, false);
}

export function MonitResolutionTypesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitResolutionTypes {
    return json as MonitResolutionTypes;
}

export function MonitResolutionTypesToJSON(value?: MonitResolutionTypes | null): any {
    return value as any;
}

